export const DASHBOARD_ROOT = "/dash";
export const ROOT = "/";

export const DASHBOARD_ROUTES = {
  Profile: `${DASHBOARD_ROOT}/profile`,
  Events: `${DASHBOARD_ROOT}/events`,
  Payments: `${DASHBOARD_ROOT}/payments`,
  broadcastArea: `${DASHBOARD_ROOT}/broadcast`,
  arvutSystem: `${DASHBOARD_ROOT}/arvutsytem`,
  archive: `${DASHBOARD_ROOT}/archive`,
  membership: `${DASHBOARD_ROOT}/membership`,
  events: `${DASHBOARD_ROOT}/events`,
  status: `${DASHBOARD_ROOT}/membership`,
  previousPayment: `${DASHBOARD_ROOT}/membership/payments`,
};
